import './Testimonial.scss'

function Testimonial() {
    return (
        <div className='Testimonial'>
        </div>
    )
}

export default Testimonial
